<svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
        <path d="M20 0c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0zm-4.918 13.275v12.789c0 1.153 1.191 1.847 2.12 1.27l10.304-6.394c.92-.568.922-1.97 0-2.539l-10.305-6.396c-.837-.52-2.119-.015-2.119 1.27z" id="u4wqxxsh0a"/>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <mask id="982lqg12sb" fill="#fff">
            <use xlink:href="#u4wqxxsh0a"/>
        </mask>
        <use fill="currentColor" xlink:href="#u4wqxxsh0a"/>
        <g mask="url(#982lqg12sb)" fill="currentColor">
            <path d="M0 0h40v40H0z"/>
        </g>
    </g>
</svg>
